export default "__VITE_ASSET__CIIv8jZ6__"